/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as VerifyEmailRouteImport } from './routes/verify-email';
import { Route as ResetPasswordRouteImport } from './routes/reset-password';
import { Route as RegisterRouteImport } from './routes/register';
import { Route as LoginRouteImport } from './routes/login';
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password';
import { Route as AuthRouteImport } from './routes/_auth';
import { Route as AuthIndexRouteImport } from './routes/_auth.index';
import { Route as AuthVrfsRouteImport } from './routes/_auth.vrfs';
import { Route as AuthSitesRouteImport } from './routes/_auth.sites';
import { Route as AuthSettingsRouteImport } from './routes/_auth.settings';
import { Route as AuthPrefixesRouteImport } from './routes/_auth.prefixes';
import { Route as AuthDevicesRouteImport } from './routes/_auth.devices';
import { Route as AuthCgnatRouteImport } from './routes/_auth.cgnat';
import { Route as AuthAuditRouteImport } from './routes/_auth.audit';
import { Route as AuthAsnsRouteImport } from './routes/_auth.asns';
import { Route as AuthAddressesRouteImport } from './routes/_auth.addresses';
import { Route as AuthPrefixesIdRouteImport } from './routes/_auth.prefixes.$id';
import { Route as AuthCgnatPoolIdRouteImport } from './routes/_auth.cgnat.$poolId';

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any);
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any);
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any);
const AuthVrfsRoute = AuthVrfsRouteImport.update({
  id: '/vrfs',
  path: '/vrfs',
  getParentRoute: () => AuthRoute,
} as any);
const AuthSitesRoute = AuthSitesRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => AuthRoute,
} as any);
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any);
const AuthPrefixesRoute = AuthPrefixesRouteImport.update({
  id: '/prefixes',
  path: '/prefixes',
  getParentRoute: () => AuthRoute,
} as any);
const AuthDevicesRoute = AuthDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AuthRoute,
} as any);
const AuthCgnatRoute = AuthCgnatRouteImport.update({
  id: '/cgnat',
  path: '/cgnat',
  getParentRoute: () => AuthRoute,
} as any);
const AuthAuditRoute = AuthAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthRoute,
} as any);
const AuthAsnsRoute = AuthAsnsRouteImport.update({
  id: '/asns',
  path: '/asns',
  getParentRoute: () => AuthRoute,
} as any);
const AuthAddressesRoute = AuthAddressesRouteImport.update({
  id: '/addresses',
  path: '/addresses',
  getParentRoute: () => AuthRoute,
} as any);
const AuthPrefixesIdRoute = AuthPrefixesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthPrefixesRoute,
} as any);
const AuthCgnatPoolIdRoute = AuthCgnatPoolIdRouteImport.update({
  id: '/$poolId',
  path: '/$poolId',
  getParentRoute: () => AuthCgnatRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/login': typeof LoginRoute;
  '/register': typeof RegisterRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/verify-email': typeof VerifyEmailRoute;
  '/addresses': typeof AuthAddressesRoute;
  '/asns': typeof AuthAsnsRoute;
  '/audit': typeof AuthAuditRoute;
  '/cgnat': typeof AuthCgnatRouteWithChildren;
  '/devices': typeof AuthDevicesRoute;
  '/prefixes': typeof AuthPrefixesRouteWithChildren;
  '/settings': typeof AuthSettingsRoute;
  '/sites': typeof AuthSitesRoute;
  '/vrfs': typeof AuthVrfsRoute;
  '/cgnat/$poolId': typeof AuthCgnatPoolIdRoute;
  '/prefixes/$id': typeof AuthPrefixesIdRoute;
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute;
  '/login': typeof LoginRoute;
  '/register': typeof RegisterRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/verify-email': typeof VerifyEmailRoute;
  '/addresses': typeof AuthAddressesRoute;
  '/asns': typeof AuthAsnsRoute;
  '/audit': typeof AuthAuditRoute;
  '/cgnat': typeof AuthCgnatRouteWithChildren;
  '/devices': typeof AuthDevicesRoute;
  '/prefixes': typeof AuthPrefixesRouteWithChildren;
  '/settings': typeof AuthSettingsRoute;
  '/sites': typeof AuthSitesRoute;
  '/vrfs': typeof AuthVrfsRoute;
  '/': typeof AuthIndexRoute;
  '/cgnat/$poolId': typeof AuthCgnatPoolIdRoute;
  '/prefixes/$id': typeof AuthPrefixesIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_auth': typeof AuthRouteWithChildren;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/login': typeof LoginRoute;
  '/register': typeof RegisterRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/verify-email': typeof VerifyEmailRoute;
  '/_auth/addresses': typeof AuthAddressesRoute;
  '/_auth/asns': typeof AuthAsnsRoute;
  '/_auth/audit': typeof AuthAuditRoute;
  '/_auth/cgnat': typeof AuthCgnatRouteWithChildren;
  '/_auth/devices': typeof AuthDevicesRoute;
  '/_auth/prefixes': typeof AuthPrefixesRouteWithChildren;
  '/_auth/settings': typeof AuthSettingsRoute;
  '/_auth/sites': typeof AuthSitesRoute;
  '/_auth/vrfs': typeof AuthVrfsRoute;
  '/_auth/': typeof AuthIndexRoute;
  '/_auth/cgnat/$poolId': typeof AuthCgnatPoolIdRoute;
  '/_auth/prefixes/$id': typeof AuthPrefixesIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/addresses'
    | '/asns'
    | '/audit'
    | '/cgnat'
    | '/devices'
    | '/prefixes'
    | '/settings'
    | '/sites'
    | '/vrfs'
    | '/cgnat/$poolId'
    | '/prefixes/$id';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/addresses'
    | '/asns'
    | '/audit'
    | '/cgnat'
    | '/devices'
    | '/prefixes'
    | '/settings'
    | '/sites'
    | '/vrfs'
    | '/'
    | '/cgnat/$poolId'
    | '/prefixes/$id';
  id:
    | '__root__'
    | '/_auth'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/_auth/addresses'
    | '/_auth/asns'
    | '/_auth/audit'
    | '/_auth/cgnat'
    | '/_auth/devices'
    | '/_auth/prefixes'
    | '/_auth/settings'
    | '/_auth/sites'
    | '/_auth/vrfs'
    | '/_auth/'
    | '/_auth/cgnat/$poolId'
    | '/_auth/prefixes/$id';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren;
  ForgotPasswordRoute: typeof ForgotPasswordRoute;
  LoginRoute: typeof LoginRoute;
  RegisterRoute: typeof RegisterRoute;
  ResetPasswordRoute: typeof ResetPasswordRoute;
  VerifyEmailRoute: typeof VerifyEmailRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email';
      path: '/verify-email';
      fullPath: '/verify-email';
      preLoaderRoute: typeof VerifyEmailRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reset-password': {
      id: '/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof ResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/register': {
      id: '/register';
      path: '/register';
      fullPath: '/register';
      preLoaderRoute: typeof RegisterRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/forgot-password': {
      id: '/forgot-password';
      path: '/forgot-password';
      fullPath: '/forgot-password';
      preLoaderRoute: typeof ForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_auth': {
      id: '/_auth';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_auth/': {
      id: '/_auth/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AuthIndexRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/vrfs': {
      id: '/_auth/vrfs';
      path: '/vrfs';
      fullPath: '/vrfs';
      preLoaderRoute: typeof AuthVrfsRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/sites': {
      id: '/_auth/sites';
      path: '/sites';
      fullPath: '/sites';
      preLoaderRoute: typeof AuthSitesRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/settings': {
      id: '/_auth/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof AuthSettingsRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/prefixes': {
      id: '/_auth/prefixes';
      path: '/prefixes';
      fullPath: '/prefixes';
      preLoaderRoute: typeof AuthPrefixesRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/devices': {
      id: '/_auth/devices';
      path: '/devices';
      fullPath: '/devices';
      preLoaderRoute: typeof AuthDevicesRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/cgnat': {
      id: '/_auth/cgnat';
      path: '/cgnat';
      fullPath: '/cgnat';
      preLoaderRoute: typeof AuthCgnatRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/audit': {
      id: '/_auth/audit';
      path: '/audit';
      fullPath: '/audit';
      preLoaderRoute: typeof AuthAuditRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/asns': {
      id: '/_auth/asns';
      path: '/asns';
      fullPath: '/asns';
      preLoaderRoute: typeof AuthAsnsRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/addresses': {
      id: '/_auth/addresses';
      path: '/addresses';
      fullPath: '/addresses';
      preLoaderRoute: typeof AuthAddressesRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/prefixes/$id': {
      id: '/_auth/prefixes/$id';
      path: '/$id';
      fullPath: '/prefixes/$id';
      preLoaderRoute: typeof AuthPrefixesIdRouteImport;
      parentRoute: typeof AuthPrefixesRoute;
    };
    '/_auth/cgnat/$poolId': {
      id: '/_auth/cgnat/$poolId';
      path: '/$poolId';
      fullPath: '/cgnat/$poolId';
      preLoaderRoute: typeof AuthCgnatPoolIdRouteImport;
      parentRoute: typeof AuthCgnatRoute;
    };
  }
}

interface AuthCgnatRouteChildren {
  AuthCgnatPoolIdRoute: typeof AuthCgnatPoolIdRoute;
}

const AuthCgnatRouteChildren: AuthCgnatRouteChildren = {
  AuthCgnatPoolIdRoute: AuthCgnatPoolIdRoute,
};

const AuthCgnatRouteWithChildren = AuthCgnatRoute._addFileChildren(
  AuthCgnatRouteChildren,
);

interface AuthPrefixesRouteChildren {
  AuthPrefixesIdRoute: typeof AuthPrefixesIdRoute;
}

const AuthPrefixesRouteChildren: AuthPrefixesRouteChildren = {
  AuthPrefixesIdRoute: AuthPrefixesIdRoute,
};

const AuthPrefixesRouteWithChildren = AuthPrefixesRoute._addFileChildren(
  AuthPrefixesRouteChildren,
);

interface AuthRouteChildren {
  AuthAddressesRoute: typeof AuthAddressesRoute;
  AuthAsnsRoute: typeof AuthAsnsRoute;
  AuthAuditRoute: typeof AuthAuditRoute;
  AuthCgnatRoute: typeof AuthCgnatRouteWithChildren;
  AuthDevicesRoute: typeof AuthDevicesRoute;
  AuthPrefixesRoute: typeof AuthPrefixesRouteWithChildren;
  AuthSettingsRoute: typeof AuthSettingsRoute;
  AuthSitesRoute: typeof AuthSitesRoute;
  AuthVrfsRoute: typeof AuthVrfsRoute;
  AuthIndexRoute: typeof AuthIndexRoute;
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAddressesRoute: AuthAddressesRoute,
  AuthAsnsRoute: AuthAsnsRoute,
  AuthAuditRoute: AuthAuditRoute,
  AuthCgnatRoute: AuthCgnatRouteWithChildren,
  AuthDevicesRoute: AuthDevicesRoute,
  AuthPrefixesRoute: AuthPrefixesRouteWithChildren,
  AuthSettingsRoute: AuthSettingsRoute,
  AuthSitesRoute: AuthSitesRoute,
  AuthVrfsRoute: AuthVrfsRoute,
  AuthIndexRoute: AuthIndexRoute,
};

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  VerifyEmailRoute: VerifyEmailRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
